// tslint:disable: max-line-length
import * as Constants from "Data/Constants";
import {JUNEAU as VO} from "Data/VO";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

export const JuneauConfig: ILocationConfig = {
  exterior: {
    width: 3072,
    margin: {
      left: 50,
      right: 50,
    },
    bg: [{
      filename: "background-juneau-exterior-1",
      x: 0,
      y: 0,
    },
    {
      filename: "background-juneau-exterior-2",
      x: 1024,
      y: 0,
    },
    {
      filename: "background-juneau-exterior-3",
      x: 2048,
      y: 0,
    }],
  },
  interior: {
    width: 1664,
    bg: {
      filename: "background-juneau-interior",
    },
    itemslist: {
      give: {
        ICON_SIZE: 100,
        ICON_SPACING: 25,
        columns: 4,
        floatingItemsY: -80,
        highlightFloatingItems: false,
        bg: [{ filename: "bulletin-board", x: -50, y: 0 }],
        width: 535,
        animateIn: "scaleItemsUp",
      },
      return: {
        ICON_SIZE: 140,
        ICON_SPACING: -12,
        floatingItemsY: -250,
        width: 459,
        height: 311,
        itemslots: [
          // for Level 5
          { x: 45 - 80, y: 2, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 172 - 80, y: 6, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 299.5 - 80, y: 2.5, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 42 - 80, y: 142.5, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 170 - 80, y: 146, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 299 - 80, y: 143, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 428 - 80, y: 2, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
          { x: 428 - 80, y: 143, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
        ],
        bg: [{ filename: "bulletin-board", x: -50, y: 0 }],
        animateOut: "none",
      },
    },
  },
  city: "Juneau",
  country: "USA",
  items: {
    "porcupine": {
      name: "Porcupine",
      sprite: "porcupine-full",
      icon_int_give: "porcupine-full",
      icon_int_return: "picture-porcupine",
      icon_ext: "porcupine-small-on",
      sprite_hat: "picture-porcupine",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ3B,
        returned: VO.ITEMS.IJ3A,
        fact: VO.FACTS.FJ9,
      },
    },
    "wood-pecker": {
      name: "Woodpecker",
      sprite: "woodpecker-full",
      icon_int_give: "woodpecker-full",
      icon_int_return: "picture-wood-pecker",
      icon_ext: "woodpecker-small-on",
      sprite_hat: "picture-wood-pecker",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ2B,
        returned: VO.ITEMS.IJ2A,
        fact: VO.FACTS.FJ7,
      },
    },
    "turtle": {
      name: "Turtle",
      sprite: "turtle-full",
      icon_int_give: "turtle-full",
      icon_int_return: "picture-turtle",
      icon_ext: "turtle-small-on",
      sprite_hat: "picture-turtle",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ7B,
        returned: VO.ITEMS.IJ7A,
      },
    },
    "bald-eagle": {
      name: "Bald-eagle",
      sprite: "baldeagle-full",
      icon_int_give: "baldeagle-full",
      icon_int_return: "picture-baldeagle",
      icon_ext: "baldeagle-small-on",
      sprite_hat: "picture-baldeagle",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ5B,
        returned: VO.ITEMS.IJ5A,
        fact: VO.FACTS.FJ10,
      },
    },
    "snail": {
      name: "Snail",
      sprite: "snail-full",
      icon_int_give: "snail-full",
      icon_int_return: "picture-snail",
      icon_ext: "snail-small-on",
      sprite_hat: "picture-snail",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ9B,
        returned: VO.ITEMS.IJ9A,
      },
    },
    "moose": {
      name: "Moose",
      sprite: "moose-full",
      icon_int_give: "moose-full",
      icon_int_return: "picture-moose",
      icon_ext: "moose-small-on",
      sprite_hat: "picture-moose",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ6B,
        returned: VO.ITEMS.IJ6A,
      },
    },
    "beaver": {
      name: "Beaver",
      sprite: "beaver-full",
      icon_int_give: "beaver-full",
      icon_int_return: "picture-beaver",
      icon_ext: "beaver-small-on",
      sprite_hat: "picture-beaver",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ4B,
        returned: VO.ITEMS.IJ4A,
        fact: VO.FACTS.FJ8,
      },
    },
    "bear": {
      name: "Bear",
      sprite: "bear-full",
      icon_int_give: "bear-full",
      icon_int_return: "picture-bear",
      icon_ext: "bear-small-on",
      sprite_hat: "picture-bear",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ1B,
        returned: VO.ITEMS.IJ1A,
        fact: VO.FACTS.FJ6,
      },
    },
    "raven": {
      name: "Raven",
      sprite: "raven-full",
      icon_int_give: "raven-full",
      icon_int_return: "picture-raven",
      icon_ext: "raven-small-on",
      sprite_hat: "picture-raven",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ8B,
        returned: VO.ITEMS.IJ8A,
        fact: VO.FACTS.FJ13,
      },
    },
    "deer": {
      name: "Deer",
      sprite: "deer-full",
      icon_int_give: "deer-full",
      icon_int_return: "picture-deer",
      icon_ext: "deer-on",
      sprite_hat: "picture-deer",
      photoMode: true,
      vo: {
        found: VO.ITEMS.IJ10B,
        returned: VO.ITEMS.IJ10A,
        fact: VO.FACTS.FJ12,
      },
    },
  },
  payoffs: {
    photoalbum: { name: "Photo Album" },
  },
  hidingspots: {
    "small-rock": {
      foreground: { sprite: "small-rock", x: 2573, y: 573.5 },
      hitarea: { x: 2646, y: 605.75, width: 146, height: 64.5 },
    },
    "beaver-dam": {
      foreground: { sprite: "beaver-dam", x: 2716, y: 455 },
      hitarea: { x: 3000, y: 583.5, width: 568, height: 257 },
    },
    "tree-group-2": {
      foreground: { sprite: "tree-group-2", x: 826, y: 0 },
      hitarea: { x: 996, y: 327, width: 416, height: 633 },
    },
    "rock-with-moss": {
      foreground: { sprite: "rock-with-moss", x: 1002, y: 581.5 },
      hitarea: { x: 1352.57, y: 682.25, width: 701, height: 201.5 },
    },
    "front-rock": {
      foreground: { sprite: "front-rock", x: 2338, y: 467.5 },
      hitarea: { x: 2515.5, y: 520, width: 380.5, height: 112 },
    },
    "creek-rock": {
      foreground: { sprite: "creek-rock", x: 2020.25, y: 641.5 },
      hitarea: { x: 2259, y: 705, width: 477.5, height: 131 },
    },
    "tree-group-3": {
      foreground: { sprite: "tree-group-3", x: 1596, y: 0 },
      hitarea: { x: 1872.25, y: 287.75, width: 552.5, height: 575.5 },
    },
    "large-rock": {
      foreground: { sprite: "large-rock", x: 1823, y: 529 },
      hitarea: { x: 1950.25, y: 585.5, width: 254.5, height: 113 },
    },
    "tree-group-1": {
      foreground: { sprite: "tree-group-1", x: 239, y: -181.7 },
      hitarea: { x: 384, y: 221.5, width: 290, height: 503 },
    },
    "left-rock": {
      foreground: { sprite: "left-rock", x: 254.75, y: 493.25 },
      hitarea: { x: 402.5, y: 621.5, width: 295.5, height: 256.5 },
    },
  },
  npc: {
    name: "Skye",
    poses: {
      neutral: { sprite: "npc-skye-neutral", position: { x: -5, y: 0 } },
      excited: { sprite: "npc-skye-excited" },
    },
  },
  vo: {
    give_quest: [VO.GIVE.J1],
    show_items: [VO.GIVE.J2, Constants.VO_SPACING, VO.GIVE.J3],
    give_quest_idle: [VO.GIVE.J4, VO.GIVE.J5],
    return_items: [VO.RETURN.J8, Constants.VO_SPACING, VO.RETURN.J9],
    return_items_idle: [VO.RETURN.J9],
    exterior: [VO.EXTERIOR.J6, Constants.VO_SPACING, VO.EXTERIOR.J7],
    exterior_idle: [VO.FACTS.FJ1, VO.FACTS.FJ2, VO.FACTS.FJ3, VO.FACTS.FJ4, VO.FACTS.FJ5],
    all_items_returned_idle: [VO.RETURN.J13],
  },
  narratives: [{
    variations: [
      // Level 1
      {
        hiddenitems: [
          {
            hidingspot: {
              id: "left-rock",
            },
            item: {
              id: "bear",
              scale: 0.7643,
              flipX: true,
              rotation: 0,
              position: { x: -28.19, y: -56.75 },
            },
          },
          {
            hidingspot: "tree-group-2",
            item: {
              id: "wood-pecker",
              rotation: 61.74,
              scale: 0.6265,
              position: {
                x: 106.25, y: -152.25,
              },
            },
          },
          {
            hidingspot: "large-rock",
            item: {
              id: "porcupine",
              rotation: 1.69,
              scale: 0.553,
              flipX: true,
              position: {
                x: -77.25, y: -15.25,
              },
            },
          },
          {
            hidingspot: "beaver-dam",
            item: {
              id: "beaver",
              rotation: 0,
              scale: 0.7118,
              flipX: false,
              position: {
                x: -50.71, y: -94.25,
              },
            },
          },
        ],
        itemslist: {
          give: {
            ICON_SIZE: 100,
            ICON_SPACING: 25,
            columns: 4,
            floatingItemsY: -10,
            highlightFloatingItems: false,
            bg: [{ filename: "bulletin-board", x: -50, y: 0 }],
            width: 475,
            animateIn: "scaleItemsUp",
          },
          return: {
            ICON_SIZE: 140,
            ICON_SPACING: 25,
            floatingItemsY: -250,
            width: 475,
            height: 338,
            itemslots: [
              { x: 118, y: 10, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 251, y: 10, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 113, y: 152, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 249, y: 153, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
            ],
            bg: [{ filename: "bulletin-board", x: -50, y: 0 }],
            animateOut: "none",
          },
        },
        vo: {
          all_items_returned: [VO.RETURN.J10, Constants.VO_SPACING, VO.RETURN.J13],
        },
      },
      // Level 2
      {
        hiddenitems: [
          {
            hidingspot: "tree-group-1",
            item: {
              id: "bald-eagle",
              rotation: 0,
              scale: 0.6961,
              flipX: false,
              position: {
                x: -240, y: 107.75,
              },
            },
          },
          {
            hidingspot: "tree-group-2",
            item: {
              id: "moose",
              rotation: -10.63,
              scale: 0.4232,
              flipX: true,
              position: {
                x: -85, y: 50.25,
              },
            },
          },
          {
            hidingspot: "rock-with-moss",
            item: {
              id: "turtle",
              rotation: 0,
              scale: 0.6891,
              flipX: true,
              position: {
                x: 170.43, y: -3.25,
              },
            },
          },
          {
            hidingspot: "tree-group-3",
            item: {
              id: "raven",
              rotation: 14.97,
              scale: 0.2407,
              position: {
                x: 51.25, y: -146.75,
              },
            },
          },
          {
            hidingspot: "small-rock",
            item: {
              id: "snail",
              scale: 0.5192,
              flipX: false,
              rotation: 0,
              position: { x: -46.51, y: -9.25 },
            },
          },
        ],
        itemslist: {
          give: {
            columns: 3,
          },
          return: {
            itemslots: [
              { x: 45 - 40, y: 2, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 172 - 30, y: 6, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299.5 - 20, y: 2.5, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },

              { x: 170 - 85, y: 147, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299 - 75, y: 148, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
            ],
          },
        },
        vo: {
          all_items_returned: [VO.RETURN.J11, Constants.VO_SPACING, VO.RETURN.J13],
        },
      },
      // Level 3
      {
        hiddenitems: [
          {
            hidingspot: "left-rock",
            item: {
              id: "deer",
              rotation: -7.15,
              scale: 0.8536,
              flipX: false,
              position: {
                x: -40, y: -71.5,
              },
            },
          },
          {
            hidingspot: "rock-with-moss",
            item: {
              id: "beaver",
              rotation: -23.63,
              scale: 0.8559,
              flipX: false,
              position: {
                x: -301, y: 55.25,
              },
            },
          },
          {
            hidingspot: "tree-group-3",
            item: {
              id: "wood-pecker",
              rotation: -46.47,
              scale: 0.6265,
              flipX: true,
              position: {
                x: -167.25, y: -108.25,
              },
            },
          },
          {
            hidingspot: "creek-rock",
            item: {
              id: "turtle",
              scale: 0.5524,
              flipX: true,
              rotation: -5.47,
              position: { x: 105.25, y: 14.25 },
            },
          },
          {
            hidingspot: "beaver-dam",
            item: {
              id: "porcupine",
              rotation: 0,
              flipX: true,
              scale: 0.5738,
              position: {
                x: -50.75, y: -81.25,
              },
            },
          },
        ],
        itemslist: {
          give: {
            columns: 3,
          },
          return: {
            itemslots: [
              { x: 45 - 40, y: 2, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 172 - 30, y: 6, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299.5 - 20, y: 2.5, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },

              { x: 170 - 85, y: 147, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299 - 75, y: 148, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
            ],
          },
        },
        vo: {
          all_items_returned: [VO.RETURN.J12, Constants.VO_SPACING, VO.RETURN.J13],
        },
      },
      // Level 4
      {
        hiddenitems: [
          {
            hidingspot: "left-rock",
            item: {
              id: "porcupine",
              rotation: 0,
              scale: 0.7967,
              flipX: false,
              position: {
                x: 41.5, y: 13,
              },
            },
          },
          {
            hidingspot: "tree-group-1",
            item: {
              id: "bear",
              rotation: 9.44,
              scale: 0.3627,
              flipX: false,
              position: {
                x: 80.25, y: 107.5,
              },
            },
          },
          {
            hidingspot: "tree-group-2",
            item: {
              id: "turtle",
              rotation: 0,
              scale: 0.4195,
              flipX: true,
              position: {
                x: 190, y: 217,
              },
            },
          },
          {
            hidingspot: "creek-rock",
            item: {
              id: "beaver",
              scale: 0.5526,
              flipX: false,
              rotation: -15.44,
              position: { x: -210.5, y: 59 },
            },
          },
          {
            hidingspot: "large-rock",
            item: {
              id: "snail",
              scale: 0.5549,
              flipX: false,
              rotation: 0,
              position: { x: -92.75, y: 6.25 },
            },
          },
          {
            hidingspot: "beaver-dam",
            item: {
              id: "deer",
              rotation: -15.36,
              flipX: true,
              scale: 0.8127,
              position: {
                x: 25.25, y: -39.25,
              },
            },
          },
        ],
        itemslist: {
          give: {
            columns: 3,
          },
          return: {
            itemslots: [
              { x: 45 - 40, y: 2, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 172 - 30, y: 6, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299.5 - 20, y: 2.5, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },

              { x: 42 - 40, y: 147, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 170 - 30, y: 148, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
              { x: 299 - 20, y: 146, width: 115.5, height: 127, bg: [{ filename: "projectboard-slot", x: 63, y: 68.5 }], dropSFX: "impact-2" },
            ],
          },
        },
        vo: {
          all_items_returned: [VO.RETURN.J10, Constants.VO_SPACING, VO.RETURN.J13],
        },
      },
      // Level 5
      {
        hiddenitems: [
          {
            hidingspot: "tree-group-1",
            item: {
              id: "beaver",
              rotation: 0,
              scale: 0.3223,
              flipX: true,
              position: {
                x: 32.75, y: 232.75,
              },
            },
          },
          {
            hidingspot: "left-rock",
            item: {
              id: "snail",
              rotation: 2.97,
              scale: 0.6685,
              flipX: true,
              position: {
                x: 97, y: 32.5,
              },
            },
          },
          {
            hidingspot: "tree-group-2",
            item: {
              id: "deer",
              rotation: -13.22,
              scale: 0.5,
              flipX: true,
              position: {
                x: -53.25, y: 119,
              },
            },
          },
          {
            hidingspot: "rock-with-moss",
            item: {
              id: "turtle",
              scale: 0.5787,
              flipX: true,
              rotation: 6.65,
              position: { x: -55.75, y: -17 },
            },
          },
          {
            hidingspot: "tree-group-3",
            item: {
              id: "moose",
              scale: 0.4232,
              flipX: true,
              rotation: -10.63,
              position: { x: -170.75, y: 143 },
            },
          },
          {
            hidingspot: "large-rock",
            item: {
              id: "raven",
              rotation: -16.08,
              flipX: true,
              scale: 0.179,
              position: {
                x: 20.5, y: -40.5,
              },
            },
          },
          {
            hidingspot: "creek-rock",
            item: {
              id: "porcupine",
              scale: 0.5541,
              flipX: true,
              rotation: 15.93,
              position: { x: -201.75, y: 50.25 },
            },
          },
          {
            hidingspot: "front-rock",
            item: {
              id: "wood-pecker",
              rotation: 30.03,
              flipX: false,
              scale: 0.4407,
              position: {
                x: 124.75, y: 1,
              },
            },
          },
        ],
        vo: {
          all_items_returned: [VO.RETURN.J11, Constants.VO_SPACING, VO.RETURN.J13],
        },
      },
    ],
    payoff: "photoalbum",
  }],
  bgm: "LATW_765_happy_pacer_country_KK_extended",
};
